export const LOGIN = '🔒 LOGIN'
export const SET_PERMISSION_PENDING = '🔒 SET_PERMISSION_PENDING'
export const ENABLE_DARK_SIDE = '👀 ENABLE_DARK_SIDE'
